import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import { useState } from "react";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.45;
`
const Detalhe = styled.p`
    margin: 12px 0 0 0;
    font-size: 13px;
    color: #111;
    text-align: center;
    font-weight: 600;
`
const ErrorMsg = styled.p`
    margin: 15px 0 0 0;
    font-size: 13px;
    color: #b91c1c;
    text-align: center;
`
const BotoesWrapper = styled.div`
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${(props) => (props.cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(props) => (props.cancel ? "#333" : "white")};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s all ease;
    &:disabled {
        background-color: ${(props) => (props.cancel ? "#e5e7eb" : "#fda4af")};
        cursor: auto;
    }
    &:hover:not(:disabled) {
        background-color: ${(props) => (props.cancel ? "#d1d5db" : "#be123c")};
    }
`

const ConfirmDeleteBM = ({ bm, idPc, fecharModal, onDelete }) => {

    const api = useApi();
    const [saving, setSaving] = useState(false);
    const [erro, setErro] = useState(null);

    const handleDelete = async () => {

        if (!bm?.id || !idPc) return;

        setSaving(true);
        setErro(null);

        try {

            await api.post(
                `/Painel/API/ControleMedicao/DeleteBM/index.php?id=${bm.id}&id_pc=${idPc}`
            );

            if (onDelete) onDelete();
            fecharModal();

        } catch (error) {

            console.error("Erro ao excluir boletim:", error);
            const msg = error?.response?.data?.message || "Erro ao excluir boletim de medição.";
            setErro(msg);

        } finally {

            setSaving(false);

        }

    };

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Titulo>Excluir boletim de medição</Titulo>
                <Subtitulo>
                    O boletim será marcado como excluído. Todas as notas fiscais vinculadas a ele também
                    serão marcadas como excluídas.
                </Subtitulo>
                {bm != null && (
                    <Detalhe>
                        BM nº {bm.num_medicao} — {bm.data_medicao}
                    </Detalhe>
                )}
                {erro && <ErrorMsg>{erro}</ErrorMsg>}
                <BotoesWrapper>
                    <Botao cancel type="button" onClick={fecharModal} disabled={saving}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={saving}>
                        EXCLUIR
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );

};

export default ConfirmDeleteBM;
